import { array, type InferProps, number } from 'prop-types'
import { useContext } from 'react'
import * as React from 'react'
import { useSelector } from 'react-redux'

import { DOCUMENT_TYPE, ENTRY_TYPE } from 'shared/consts/checkout'
import { type IState } from 'types/redux/store'
import CollectiveOrderModal from 'views/components/organisms/Cart/CollectiveOrderModal'
import { DeleteEPrescriptionEntryContext } from 'views/components/organisms/Cart/DeleteEPrescriptionEntryContext'
import DeliveryCostModal from 'views/components/organisms/Cart/ProductListCart/SellerShippingAddressBox/DeliveryCostModal'
import RxBonusModal from 'views/components/organisms/Cart/RxBonusModal'
import { hasOverdraftsSelector } from 'views/components/organisms/Cart/selectors'
import DeleteEPrescriptionModal from 'views/components/organisms/DeleteEPrescriptionModal'
import OnlineDoctorServiceModal from 'views/components/pages/OnlineDoctorService/OnlineDoctorServiceModal'
import { ODS_MODAL_ID } from 'views/consts/names'

const CartModalsProps = {
  productAmount: number.isRequired,
  sellerGroups: array.isRequired,
}

type PropTypes = InferProps<typeof CartModalsProps>

const CartModals: React.FunctionComponent<PropTypes> = ({
  productAmount,
  sellerGroups,
}: PropTypes) => {
  const hasOverdrafts = useSelector(hasOverdraftsSelector)

  const shippingDetail = useSelector(
    (state: IState) => state.cart.data.shippingDetail
  )
  const currency = useSelector((state: IState) => state.cart.data.currency)

  const odsConsultationID: string | undefined =
    sellerGroups
      .flatMap(group => group.groupEntries)
      .filter(group => group.type === DOCUMENT_TYPE.ODS_SECTION)
      .flatMap(group => group.items)
      .find(item => item.entryType === ENTRY_TYPE.SERVICE)?.offerId || undefined

  // @ts-ignore
  const [ePrescriptionHashedToken] = useContext(DeleteEPrescriptionEntryContext)

  return (
    <>
      {productAmount > 0 && !hasOverdrafts && (
        <CollectiveOrderModal open={false} />
      )}

      {!!odsConsultationID && (
        // @ts-ignore
        <OnlineDoctorServiceModal
          modalId={ODS_MODAL_ID}
          size="medium"
          offerID={odsConsultationID}
        />
      )}

      <DeliveryCostModal
        sellerGroups={sellerGroups}
        shippingDetail={shippingDetail}
        currency={currency}
      />

      {/* @ts-ignore */}
      <DeleteEPrescriptionModal
        modalId="deleteEPrescriptionModal"
        size="medium"
        hashedToken={ePrescriptionHashedToken}
      />
      <RxBonusModal open={false} />
    </>
  )
}

CartModals.propTypes = CartModalsProps

export default CartModals
